<template>
    <div class="moderation page-container">
        <PageContent :content="content" scrolling>
            <form class="contact-form" action="/message.php" method="post">
                <div class="form-element">
                    <div>Firma</div>
                    <input v-model="form.company" type="text" name="company" value=""><br>
                </div>
                <div class="form-element">
                    <div>Vor- und Nachname</div>
                    <input v-model="form.name" type="text" name="name" value=""><br>
                </div>
                <div class="form-element">
                    <div>E-Mail</div>
                    <input v-model="form.email" type="email" name="email" value=""><br>
                </div>
                <div class="form-element">
                    <div>Nachricht</div>
                    <textarea v-model="form.message" type="text" name="message" value=""></textarea><br>
                </div>
                <div class="form-element" id="button-form-element">
                    <button type="submit" class="submit">Senden</button>
                </div>
                <div id="contactFormResponse"/>

                <div id="myCaptcha"></div>

            </form>
        </PageContent>


    </div>
</template>
<script>
    import kontakt from '../content/kontakt.json'
    import PageContent from "../components/PageContent";

    export default {
        metaInfo() {
            return {
                title: this.page.title,
                titleTemplate: "%s | DrThumm GmbH",
                meta: [
                    { name: 'description', content: 'Dr Thumm GmbH' }
                ]
            }
        },
        components: {
            PageContent
        },
        data() {
            return {
                showRecaptcha: false,
                content: {
                    kontakt
                },
                formResponse: '',
                form: {
                    subject: "text",
                    company: '',
                    name: '',
                    email: '',
                    message: ''
                }
            }
        },
        computed: {
            page() {
                let route = this.$route.fullPath
                let routes = route.split('/')
                var filtered = routes.filter(el => el != "" )

                let content = this.content
                console.log(content.moderation)
                filtered.forEach(r => {
                    if (filtered.length === 1) content = content[r][r]
                    else content = content[r]
                })

                return content
            }
        },
        methods: {
            // send your recaptcha token to the server to verify it
            submitr (response) {
                console.log(response)
            },
            // execute the recaptcha widget
            executeRecaptcha () {
                this.$refs.recaptcha.execute()
            }
        },
        mounted() {

            this.formResponse = "hheh "

            var captchaWidgetId = grecaptcha.render( 'myCaptcha', {
                'sitekey' : '6Lf0yZYUAAAAAEjGGV-5CjqAQBYM7jo8XrIIX1cJ',  // required
                'theme' : 'light',  // optional
                'callback': 'verifyCallback'  // optional
            });

            var verifyCallback = function( response ) {
                console.log( 'g-recaptcha-response: ' + response );
            };

            $('.contact-form').submit(e => {
                e.preventDefault()
                $.ajax({
                    url: $('.contact-form').attr('action'),
                    type: 'POST',
                    data : $('.contact-form').serialize(),
                    success: r => {
                        let res = JSON.parse(r)
                        if (res.status === "ok") {
                            $("#contactFormResponse").addClass('success')
                            $("#contactFormResponse").removeClass('error')

                        } else {
                            $("#contactFormResponse").addClass('error')
                            $("#contactFormResponse").removeClass('success')
                        }
                        $("#contactFormResponse").text(res.message)
                    }
                });
                return false
                this.form.company = ''
                this.form.name = ''
                this.form.email = ''
                this.form.message = ''
            });
        },
        beforeCreate() {
            document.body.className = ""
        }
    }
</script>
<style lang="sass">

    .contact-form
        max-width: 500px
        display: flex
        flex-direction: column

        > div
            width: 100%
            margin: 7px 0

            textarea
                font-size: 18px

            input
                width: 95%
                padding: 3px
                padding-left: 5px
                font-size: 18px
                font-family: "Rotis Sans Serif Std Regular"

                &:focus
                    outline: none

            input, textarea
                border: 1px solid #ccc

    input:focus,
        select:focus,
        textarea:focus,
        button:focus
        outline: none


    .submit
        background-color: #000
        border: none
        height: 35px
        color: #fff
        cursor: pointer
        font-size: 18px
        font-family: "Rotis Sans Serif Std Regular"
        max-width: 130px
        width: 100%
        margin-top: 20px

    textarea
        font-family: "Rotis Sans Serif Std Regular"
        resize: none
        width: 95%
        height: 100px
        padding: 3px

    #contactFormResponse
        &.success
            color: green

        &.error
            color: darkred

    #button-form-element
        height: 65px

</style>